// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1V1nK","consentsList":"PatientConsents_consentsList__36hhX","consentsListEmpty":"PatientConsents_consentsListEmpty__N3-tM"};